// Варианты координат областей для car_schema.png из разных файлов
// Используйте URL параметр ?coords=kangoo|polo|toyota|sv|xl|backup для переключения

export interface ImageAreaCoords {
  id: string;
  title: string;
  coords: string;
  view: 'side-left' | 'side-right' | 'front' | 'rear' | 'top';
  detailKeywords: string[];
}

// Вариант 1: BluePrintKangoo (исходные координаты)
export const KANGOO_COORDS: ImageAreaCoords[] = [
  {
    id: 'left-front-part',
    title: 'Front Part (Left Side)',
    coords: '34,119,27,133,24,167,66,175,83,186,106,183,118,172,127,177,124,93,78,108',
    view: 'side-left',
    detailKeywords: ['front', 'bumper', 'fender', 'headlight'],
  },
  {
    id: 'left-front-door',
    title: 'Front Door (Left Side)',
    coords: '124,94,129,174,210,177,214,65,169,68',
    view: 'side-left',
    detailKeywords: ['front', 'door'],
  },
  {
    id: 'left-back-door',
    title: 'Back Door (Left Side)',
    coords: '214,66,281,67,280,145,263,179,210,175',
    view: 'side-left',
    detailKeywords: ['back', 'rear', 'door'],
  },
  {
    id: 'left-back-part',
    title: 'Back Part (Left Side)',
    coords: '285,66,347,65,356,142,361,158,360,171,326,175,319,167,310,186,286,186,273,171,281,141,284,104',
    view: 'side-left',
    detailKeywords: ['back', 'rear', 'bumper', 'taillight'],
  },
  {
    id: 'front-view',
    title: 'Front View',
    coords: '412,57,398,113,397,186,412,186,414,172,518,176,519,189,534,189,536,142,529,103,517,56,468,53',
    view: 'front',
    detailKeywords: ['front', 'bumper', 'headlight', 'grille'],
  },
  {
    id: 'top-view',
    title: 'Top View',
    coords: '625,41,602,71,598,117,598,153,598,339,610,371,672,378,725,370,737,341,735,154,740,116,733,68,710,39',
    view: 'top',
    detailKeywords: ['top', 'roof', 'hood', 'trunk'],
  },
  {
    id: 'right-front-part',
    title: 'Front Part (Right Side)',
    coords: '264,283,261,366,276,369,295,381,315,375,330,367,366,360,359,321,339,306,290,297',
    view: 'side-right',
    detailKeywords: ['front', 'bumper', 'fender'],
  },
  {
    id: 'right-front-door',
    title: 'Front Door (Right Side)',
    coords: '177,257,181,370,263,368,264,286,221,263,193,258',
    view: 'side-right',
    detailKeywords: ['front', 'door'],
  },
  {
    id: 'right-back-door',
    title: 'Back Door (Right Side)',
    coords: '107,259,107,337,118,364,130,368,180,367,176,300,177,260',
    view: 'side-right',
    detailKeywords: ['back', 'rear', 'door'],
  },
  {
    id: 'right-back-part',
    title: 'Back Part (Right Side)',
    coords: '42,258,36,300,29,351,30,364,63,368,70,358,80,380,106,382,118,360,107,334,103,259',
    view: 'side-right',
    detailKeywords: ['back', 'rear', 'bumper'],
  },
  {
    id: 'rear-view',
    title: 'Rear View',
    coords: '415,250,396,322,398,383,412,382,415,368,516,368,519,382,533,382,538,322,518,251,465,248',
    view: 'rear',
    detailKeywords: ['rear', 'back', 'bumper', 'taillight'],
  },
];

// Вариант 2: BluePrintPolo
export const POLO_COORDS: ImageAreaCoords[] = [
  {
    id: 'left-front-part',
    title: 'Front Part (Left Side)',
    coords: '64,125,67,155,100,159,116,171,135,168,145,158,154,159,151,96,100,105',
    view: 'side-left',
    detailKeywords: ['front', 'bumper', 'fender', 'headlight'],
  },
  {
    id: 'left-front-door',
    title: 'Front Door (Left Side)',
    coords: '153,95,154,158,227,161,231,73,199,80',
    view: 'side-left',
    detailKeywords: ['front', 'door'],
  },
  {
    id: 'left-back-door',
    title: 'Back Door (Left Side)',
    coords: '233,74,227,157,278,158,279,137,288,125,295,106,286,75',
    view: 'side-left',
    detailKeywords: ['back', 'rear', 'door'],
  },
  {
    id: 'left-back-part',
    title: 'Back Part (Left Side)',
    coords: '290,76,326,85,341,114,349,130,350,141,340,152,322,155,314,170,300,172,285,165,279,147,288,128,296,104',
    view: 'side-left',
    detailKeywords: ['back', 'rear', 'bumper', 'taillight'],
  },
  {
    id: 'front-view',
    title: 'Front View',
    coords: '414,70,394,115,397,172,411,173,412,160,499,161,498,172,515,171,516,115,496,69,454,67',
    view: 'front',
    detailKeywords: ['front', 'bumper', 'headlight', 'grille'],
  },
  {
    id: 'top-view',
    title: 'Top View',
    coords: '601,92,595,156,596,295,599,327,615,346,657,359,705,344,718,323,717,294,715,157,715,100,695,74,661,66,626,71',
    view: 'top',
    detailKeywords: ['top', 'roof', 'hood', 'trunk'],
  },
  {
    id: 'right-front-part',
    title: 'Front Part (Right Side)',
    coords: '263,293,262,345,277,347,288,357,305,356,315,344,349,340,350,308,320,293,277,286',
    view: 'side-right',
    detailKeywords: ['front', 'bumper', 'fender'],
  },
  {
    id: 'right-front-door',
    title: 'Front Door (Right Side)',
    coords: '185,261,190,345,261,346,265,289,223,266',
    view: 'side-right',
    detailKeywords: ['front', 'door'],
  },
  {
    id: 'right-back-door',
    title: 'Back Door (Right Side)',
    coords: '116,270,143,347,190,345,188,289,184,260,143,263',
    view: 'side-right',
    detailKeywords: ['back', 'rear', 'door'],
  },
  {
    id: 'right-back-part',
    title: 'Back Part (Right Side)',
    coords: '95,267,77,294,68,312,67,328,77,340,95,344,105,354,127,358,138,344,125,294,130,264',
    view: 'side-right',
    detailKeywords: ['back', 'rear', 'bumper'],
  },
  {
    id: 'rear-view',
    title: 'Rear View',
    coords: '413,257,392,294,395,357,411,358,412,343,499,344,502,355,515,358,516,298,496,253,455,250',
    view: 'rear',
    detailKeywords: ['rear', 'back', 'bumper', 'taillight'],
  },
];

// Вариант 3: BluePrintToyota
export const TOYOTA_COORDS: ImageAreaCoords[] = [
  {
    id: 'left-front-part',
    title: 'Front Part (Left Side)',
    coords: '24,120,27,154,65,159,89,176,110,161,125,160,123,102,90,97,48,107',
    view: 'side-left',
    detailKeywords: ['front', 'bumper', 'fender', 'headlight'],
  },
  {
    id: 'left-front-door',
    title: 'Front Door (Left Side)',
    coords: '207,73,201,160,126,158,123,100,169,76',
    view: 'side-left',
    detailKeywords: ['front', 'door'],
  },
  {
    id: 'left-back-door',
    title: 'Back Door (Left Side)',
    coords: '211,71,278,80,280,107,267,137,267,159,203,160,204,114',
    view: 'side-left',
    detailKeywords: ['back', 'rear', 'door'],
  },
  {
    id: 'left-back-part',
    title: 'Back Part (Left Side)',
    coords: '280,77,354,98,361,125,361,149,339,156,318,156,301,171,282,173,266,157,273,126,280,108',
    view: 'side-left',
    detailKeywords: ['back', 'rear', 'bumper', 'taillight'],
  },
  {
    id: 'front-view',
    title: 'Front View',
    coords: '424,69,399,117,402,174,417,175,421,158,512,160,517,174,532,173,534,118,511,70,470,66',
    view: 'front',
    detailKeywords: ['front', 'bumper', 'headlight', 'grille'],
  },
  {
    id: 'top-view',
    title: 'Top View',
    coords: '638,36,612,55,602,79,603,319,604,343,634,378,706,378,732,344,733,320,733,82,722,55,698,36',
    view: 'top',
    detailKeywords: ['top', 'roof', 'hood', 'trunk'],
  },
  {
    id: 'right-front-part',
    title: 'Front Part (Right Side)',
    coords: '270,281,266,343,287,345,304,356,324,348,335,340,366,335,368,301,329,284,285,278',
    view: 'side-right',
    detailKeywords: ['front', 'bumper', 'fender'],
  },
  {
    id: 'right-front-door',
    title: 'Front Door (Right Side)',
    coords: '181,253,191,341,266,340,267,280,220,260',
    view: 'side-right',
    detailKeywords: ['front', 'door'],
  },
  {
    id: 'right-back-door',
    title: 'Back Door (Right Side)',
    coords: '181,253,129,260,111,288,131,341,190,340',
    view: 'side-right',
    detailKeywords: ['back', 'rear', 'door'],
  },
  {
    id: 'right-back-part',
    title: 'Back Part (Right Side)',
    coords: '125,262,37,277,38,293,32,303,31,315,30,330,56,340,77,337,87,352,113,354,126,339,117,304,109,286',
    view: 'side-right',
    detailKeywords: ['back', 'rear', 'bumper'],
  },
  {
    id: 'rear-view',
    title: 'Rear View',
    coords: '425,249,401,293,402,351,418,353,420,340,513,340,517,353,533,353,533,295,511,250,470,247',
    view: 'rear',
    detailKeywords: ['rear', 'back', 'bumper', 'taillight'],
  },
];

// Вариант 4: BluePrintSV
export const SV_COORDS: ImageAreaCoords[] = [
  {
    id: 'left-front-part',
    title: 'Front Part (Left Side)',
    coords: '30,110,87,94,132,95,133,163,117,169,97,183,78,175,54,162,28,156,24,132',
    view: 'side-left',
    detailKeywords: ['front', 'bumper', 'fender', 'headlight'],
  },
  {
    id: 'left-front-door',
    title: 'Front Door (Left Side)',
    coords: '133,92,182,66,217,64,213,162,133,163',
    view: 'side-left',
    detailKeywords: ['front', 'door'],
  },
  {
    id: 'left-back-door',
    title: 'Back Door (Left Side)',
    coords: '212,162,275,161,295,120,292,85,277,64,220,63',
    view: 'side-left',
    detailKeywords: ['back', 'rear', 'door'],
  },
  {
    id: 'left-back-part',
    title: 'Back Part (Left Side)',
    coords: '281,66,343,70,365,95,365,121,373,127,366,154,336,158,320,183,294,183,278,165,288,137,294,133,296,112',
    view: 'side-left',
    detailKeywords: ['back', 'rear', 'bumper', 'taillight'],
  },
  {
    id: 'front-view',
    title: 'Front View',
    coords: '418,183,438,181,439,160,538,160,539,182,563,183,562,153,560,109,542,59,439,58,414,109',
    view: 'front',
    detailKeywords: ['front', 'bumper', 'headlight', 'grille'],
  },
  {
    id: 'top-view',
    title: 'Top View',
    coords: '614,370,609,249,609,126,610,77,651,42,716,44,755,74,756,157,755,267,754,362,728,386,663,390,637,385',
    view: 'top',
    detailKeywords: ['top', 'roof', 'hood', 'trunk'],
  },
  {
    id: 'right-front-part',
    title: 'Front Part (Right Side)',
    coords: '272,351,277,288,298,284,314,283,372,299,380,322,378,345,341,350,324,370,298,366',
    view: 'side-right',
    detailKeywords: ['front', 'bumper', 'fender'],
  },
  {
    id: 'right-front-door',
    title: 'Front Door (Right Side)',
    coords: '191,350,187,250,229,256,276,286,271,351',
    view: 'side-right',
    detailKeywords: ['front', 'door'],
  },
  {
    id: 'right-back-door',
    title: 'Back Door (Right Side)',
    coords: '190,348,128,347,125,315,110,307,112,275,126,252,185,250',
    view: 'side-right',
    detailKeywords: ['back', 'rear', 'door'],
  },
  {
    id: 'right-back-part',
    title: 'Back Part (Right Side)',
    coords: '42,342,33,325,33,310,40,278,61,254,126,252,110,307,127,347,120,362,98,370,80,362,70,343',
    view: 'side-right',
    detailKeywords: ['back', 'rear', 'bumper'],
  },
  {
    id: 'rear-view',
    title: 'Rear View',
    coords: '417,368,436,367,439,347,537,348,540,370,562,369,562,292,545,249,533,242,489,242,438,242,415,285',
    view: 'rear',
    detailKeywords: ['rear', 'back', 'bumper', 'taillight'],
  },
];

// Вариант 5: BluePrintXl
export const XL_COORDS: ImageAreaCoords[] = [
  {
    id: 'left-front-part',
    title: 'Front Part (Left Side)',
    coords: '59,107,39,124,36,165,54,178,80,178,91,190,105,199,123,197,135,183,138,173,130,154,122,143,118,87',
    view: 'side-left',
    detailKeywords: ['front', 'bumper', 'fender', 'headlight'],
  },
  {
    id: 'left-front-door',
    title: 'Front Door (Left Side)',
    coords: '207,50,207,176,139,175,131,153,124,144,118,87,158,52',
    view: 'side-left',
    detailKeywords: ['front', 'door'],
  },
  {
    id: 'left-back-door',
    title: 'Back Door (Left Side)',
    coords: '209,48,301,50,300,122,294,179,208,177',
    view: 'side-left',
    detailKeywords: ['back', 'rear', 'door'],
  },
  {
    id: 'left-back-part',
    title: 'Back Part (Left Side)',
    coords: '301,51,422,54,430,101,428,161,434,165,430,175,389,176,383,183,372,195,355,199,336,190,325,176,294,177',
    view: 'side-left',
    detailKeywords: ['back', 'rear', 'bumper', 'taillight'],
  },
  {
    id: 'front-view',
    title: 'Front View',
    coords: '496,26,473,103,477,197,493,198,495,181,601,184,606,198,618,197,623,151,623,104,603,26,544,23',
    view: 'front',
    detailKeywords: ['front', 'bumper', 'headlight', 'grille'],
  },
  {
    id: 'top-view',
    title: 'Top View',
    coords: '690,14,665,54,668,382,691,404,745,404,787,403,810,382,809,50,782,12,735,6',
    view: 'top',
    detailKeywords: ['top', 'roof', 'hood', 'trunk'],
  },
  {
    id: 'right-front-part',
    title: 'Front Part (Right Side)',
    coords: '352,279,342,348,334,367,346,386,364,392,384,386,388,371,421,368,438,354,435,326,416,300',
    view: 'side-right',
    detailKeywords: ['front', 'bumper', 'fender'],
  },
  {
    id: 'right-front-door',
    title: 'Front Door (Right Side)',
    coords: '263,242,264,370,330,368,346,338,348,275,315,244',
    view: 'side-right',
    detailKeywords: ['front', 'door'],
  },
  {
    id: 'right-back-door',
    title: 'Back Door (Right Side)',
    coords: '171,244,170,312,178,369,263,371,265,244',
    view: 'side-right',
    detailKeywords: ['back', 'rear', 'door'],
  },
  {
    id: 'right-back-part',
    title: 'Back Part (Right Side)',
    coords: '49,247,41,307,44,355,42,366,81,369,89,368,99,387,115,393,133,389,143,369,179,369,169,309,169,244',
    view: 'side-right',
    detailKeywords: ['back', 'rear', 'bumper'],
  },
  {
    id: 'rear-view',
    title: 'Rear View',
    coords: '495,222,474,294,474,391,492,393,493,375,603,378,603,393,622,393,625,295,604,219,550,215',
    view: 'rear',
    detailKeywords: ['rear', 'back', 'bumper', 'taillight'],
  },
];

// Вариант 6: Текущие координаты (после всех корректировок)
export const BACKUP_COORDS: ImageAreaCoords[] = [
  {
    id: 'left-front-part',
    title: 'Front Part (Left Side)',
    coords: '34,119,27,133,24,167,66,175,83,186,106,183,118,172,127,177,124,93,78,108',
    view: 'side-left',
    detailKeywords: ['front', 'bumper', 'fender', 'headlight'],
  },
  {
    id: 'left-front-door',
    title: 'Front Door (Left Side)',
    coords: '124,94,129,174,210,177,214,65,169,68',
    view: 'side-left',
    detailKeywords: ['front', 'door'],
  },
  {
    id: 'left-back-door',
    title: 'Back Door (Left Side)',
    coords: '214,66,281,67,280,145,263,179,210,175',
    view: 'side-left',
    detailKeywords: ['back', 'rear', 'door'],
  },
  {
    id: 'left-back-part',
    title: 'Back Part (Left Side)',
    coords: '285,66,347,65,356,142,361,158,360,171,326,175,319,167,310,186,286,186,273,171,281,141,284,104',
    view: 'side-left',
    detailKeywords: ['back', 'rear', 'bumper', 'taillight'],
  },
  {
    id: 'front-view',
    title: 'Front View',
    coords: '432,57,418,113,417,186,432,186,434,172,538,176,539,189,554,189,556,142,549,103,537,56,488,53',
    view: 'front',
    detailKeywords: ['front', 'bumper', 'headlight', 'grille'],
  },
  {
    id: 'top-view',
    title: 'Top View',
    coords: '645,41,622,71,618,117,618,153,618,339,630,371,692,378,745,370,757,341,755,154,760,116,753,68,730,39',
    view: 'top',
    detailKeywords: ['top', 'roof', 'hood', 'trunk'],
  },
  {
    id: 'right-front-part',
    title: 'Front Part (Right Side)',
    coords: '284,268,281,351,296,354,315,366,335,360,350,352,386,345,379,306,359,291,310,282',
    view: 'side-right',
    detailKeywords: ['front', 'bumper', 'fender'],
  },
  {
    id: 'right-front-door',
    title: 'Front Door (Right Side)',
    coords: '177,237,181,350,263,348,264,266,221,243,193,238',
    view: 'side-right',
    detailKeywords: ['front', 'door'],
  },
  {
    id: 'right-back-door',
    title: 'Back Door (Right Side)',
    coords: '107,244,107,322,118,349,130,353,180,352,176,285,177,245',
    view: 'side-right',
    detailKeywords: ['back', 'rear', 'door'],
  },
  {
    id: 'right-back-part',
    title: 'Back Part (Right Side)',
    coords: '42,243,36,285,29,336,30,349,63,353,70,343,80,365,106,367,118,345,107,319,103,244',
    view: 'side-right',
    detailKeywords: ['back', 'rear', 'bumper'],
  },
  {
    id: 'rear-view',
    title: 'Rear View',
    coords: '440,240,421,312,423,373,437,372,440,358,541,358,544,372,558,372,563,312,543,241,490,238',
    view: 'rear',
    detailKeywords: ['rear', 'back', 'bumper', 'taillight'],
  },
];

// Функция для получения координат по варианту
export function getImageAreasByVariant(variant: string): ImageAreaCoords[] {
  switch (variant.toLowerCase()) {
    case 'kangoo':
      return KANGOO_COORDS;
    case 'polo':
      return POLO_COORDS;
    case 'toyota':
      return TOYOTA_COORDS;
    case 'sv':
      return SV_COORDS;
    case 'xl':
      return XL_COORDS;
    case 'backup':
      return BACKUP_COORDS;
    default:
      return BACKUP_COORDS; // По умолчанию используем backup (текущие)
  }
}
